module.exports = __webpack_public_path__ + "static/scale-model-of-virginia-air-&-space-center-in-hampton-virginia-c9372c4a5034956920cf1aca6363e71e.png";